<template>
  <div id="custom-table-list" class="custom-table-container">
    <vs-table
      ref="table"
      multiple
      :sst="true"
      @sort="handleSort"
      @search="handleSearch"
      noDataText="Sem dados disponíveis"
      v-model="selected"
      search
      :data="templates"
    >
      <!-- HEADER -->
      <div slot="header" id="custom-header-wrapper">
        <HeaderList
          :itemsPerPage="itemsPerPage"
          @changeItemsPerPage="setItemsPerPage"
          @emitAddNewData="addNewData"
        />
      </div>
      <!-- FIM HEADER -->

      <template slot="thead">
        <vs-th sort-key="name">Nome</vs-th>
        <vs-th>Criado Em</vs-th>
        <vs-th>Atualizado Em</vs-th>
        <vs-th>Ativo</vs-th>
        <vs-th>Ações</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

            <vs-td>
              <p class="product-name font-medium">{{ tr.name }}</p>
            </vs-td>

            <vs-td>
              <p class="font-medium">
                {{ formatStringDate(tr.created_at) }}
              </p>
            </vs-td>

            <vs-td>
              <p class="font-medium">
                {{ formatStringDate(tr.updated_at) }}
              </p>
            </vs-td>

            <vs-td>
              <p class="product-activated font-medium">
                <ActiveItem :active="tr.activated" />
              </p>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon
                icon="EditIcon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                @click.stop="editData(tr.id)"
              />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <vs-pagination :total="totalPages" v-model="currentPage"></vs-pagination>
  </div>
</template>

<script>
  import ActiveItem from '@/components/ActiveItem'
  import HeaderList from '@/views/components/custom/HeaderList'

  import moduleTemplate from '@/store/newsletter/template/moduleTemplate'
  import { defineSortFieldDirection, formatDate } from '@/utils'

  export default {
    name: 'templates-list',
    components: {
      ActiveItem,
      HeaderList
    },
    data() {
      return {
        selected: [],
        itemsPerPage: 5,
        currentPage: 1,
        isMounted: false,
        sidebarData: {},
        searchField: null,
        sortField: {
          default: 'id_desc',
          current: '',
          count: 0
        }
      }
    },
    computed: {
      templates() {
        return this.$store.state.newsletterTemplate.templates
      },
      totalPages() {
        return this.$store.state.newsletterTemplate.totalPages
      }
    },
    watch: {
      currentPage() {
        this.handleChangePage()
      },
      itemsPerPage() {
        this.handleChangePage()
      }
    },
    methods: {
      addNewData() {
        this.$router.push(`/newsletter/templates/create`)
      },
      editData(templateId) {
        this.$router.push(`/newsletter/templates/edit/${templateId}`)
      },
      setItemsPerPage(qty) {
        this.currentPage = 1
        this.itemsPerPage = qty
        //this.fetchData()
      },
      handleSort(sort) {
        if (sort !== null) {
          this.sortField.count++

          if (this.sortField.count < 3) {
            this.sortField.current = defineSortFieldDirection(this.sortField.current, sort)
          } else {
            this.resetSortField()
          }
          
          this.fetchData()
        } else {
          if (this.sortField.current !== this.sortField.default) {
            this.resetSortField()
            this.fetchData()
          }
        }
      },
      resetSortField() {
        this.sortField.current = this.sortField.default;
        this.sortField.count = 0;
      },
      handleSearch(search) {
        let searchField = null

        if (search !== "") {
          searchField = {
            name: search
          }
        }
        
        this.searchField = searchField
        this.fetchData()
      },
      handleChangePage() {
        this.fetchData()
      },
      fetchData() {
        if (moduleTemplate.isRegistered) {
          this.$store.dispatch("newsletterTemplate/fetch", {
            ...this.searchField, 
            ...{ order_by: this.sortField.current },
            ...{ pagination_page: this.currentPage, pagination_limit: this.itemsPerPage }
          })
        }
      },
      formatStringDate(date) {
        return formatDate(date).full
      }
    },
    created() {
      this.resetSortField();

      if (!moduleTemplate.isRegistered) {
        this.$store.registerModule('newsletterTemplate', moduleTemplate)
        moduleTemplate.isRegistered = true
      }
      
      this.fetchData();
    },
    mounted() {
      this.isMounted = true;
    }
  }
</script>
